import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as LockIcon } from 'assets/icons/lock.svg';
import { ReactComponent as LockedIcon } from 'assets/icons/locked.svg';
import { toggleWidgetsLock } from 'modules/Editor/Editor.helpers';
import { store, useAppSelector } from 'modules/Editor/store';
import { selectIsWidgetLockDisabled, selectIsWidgetLocked } from 'modules/Editor/store/infographSelector';
import { selectActiveWidgetIds } from 'modules/Editor/store/widgetSelector';
import { Keyboard } from 'modules/common/components/Keyboard';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const LockMenu = memo(() => {
  const { t } = useTranslation('editor_toolbar');
  const isLocked = useAppSelector(selectIsWidgetLocked);
  const isLockDisabled = useAppSelector(selectIsWidgetLockDisabled);

  const lockText = t('lockBtn.label');
  const unlockText = t('unlockBtn.label');

  const label = isLocked ? unlockText : lockText;

  const lockWidget = useCallback(() => {
    const activeWidgetIds = selectActiveWidgetIds(store.getState());
    toggleWidgetsLock(activeWidgetIds, !isLocked);
  }, [isLocked]);

  return (
    <Tooltip
      hasArrow
      placement='bottom'
      label={
        <>
          {label}
          <Keyboard shortcut={['ctrl', 'alt', 'L']} macOs={['⌘', 'Opt', 'L']} />
        </>
      }
      bg='black'
    >
      <IconButton
        size='sm'
        variant={'ghost-with-active'}
        aria-label={label}
        icon={isLocked ? <LockedIcon color='var(--vg-colors-red-500)' /> : <LockIcon />}
        _active={{ bg: 'hover.blue' }}
        onClick={lockWidget}
        isDisabled={isLockDisabled}
      />
    </Tooltip>
  );
});
LockMenu.displayName = 'LockMenu';
